import { render, staticRenderFns } from "./Desabo.vue?vue&type=template&id=773782b8&scoped=true&"
import script from "./Desabo.vue?vue&type=script&lang=js&"
export * from "./Desabo.vue?vue&type=script&lang=js&"
import style0 from "./Desabo.vue?vue&type=style&index=0&id=773782b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773782b8",
  null
  
)

export default component.exports